module.exports = __webpack_public_path__ + "img/fcf_logo.5c3ec3a0.png";